import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanKeyVisual } from "./key-visual";
import { QuestionMainTarget } from "./main-target";
import { QuestionPlanName } from "./name";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: PlanCategoriesAndManagerStore["base"];

	hotelID: string;
	planID: string;
};

export const QuestionPlanBase = ({ base, hotelID, planID }: Props) => {
	const ownerID = hotelID;
	const resourceID = planID;

	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionPlanName />
			<QuestionMainTarget />
			<QuestionPlanKeyVisual ownerID={ownerID} resourceID={resourceID} />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanBase.displayName = "QuestionPlanBase";
